import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Green_round_btn from "../../../common-components/common_btn/green_round_btn/Green_round_btn";
import { Accordion, Form } from "react-bootstrap";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import { getAllProducts } from "../../../../features/products/productsSlice";
import { useDispatch } from "react-redux";
import Black_Btn from "../../../common-components/common_btn/black_btn/Black_Btn";
import Green_Outline_Btn from "../../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";

function Sort_offcanvas({
  sortOrder,
  setSortOrder,
  show,
  handleClose,
  selectId,
  ...props
}) {
  const [modalShow, setModalShow] = React.useState(false);
  const handleClick = () => {
    setModalShow(true);
    setTimeout(() => {
      setModalShow(false);
    }, 3000);
  };

  const options = [
    { key: "best_selling", label: "Best selling" },
    { key: "az", label: "Alphabetically, A-Z" },
    { key: "za", label: "Alphabetically, Z-A" },
    { key: "low_to_high", label: "Price, low to high" },
    { key: "high_to_low", label: "Price, high to low" },
    { key: "old_to_new", label: "Date, old to new" },
    { key: "new_to_old", label: "Date, new to old" },
  ];
  const dispatch = useDispatch();
  return (
    <>
      <Offcanvas
        className="Filter_offcanvas"
        show={show}
        onHide={handleClose}
        placement="start"
        {...props}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h4 className="heading_text">Sort</h4>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* <div className="Accordion_holder">
            <div
              className="text_holder accordion-item active" 
              onClick={() => setSortOrder("best_selling")}
            >
              <p>Best selling</p>
            </div>
            <div
              className="text_holder accordion-item"
              onClick={() => setSortOrder("az")}
            >
              <p>Alphabetically, A-Z</p>
            </div>
            <div
              className="text_holder accordion-item"
              onClick={() => setSortOrder("za")}
            >
              <p>Alphabetically, Z-A</p>
            </div>
            <div
              className="text_holder accordion-item"
              onClick={() => setSortOrder("low_to_high")}
            >
              <p>Price, low to high</p>
            </div>
            <div
              className="text_holder accordion-item"
              onClick={() => setSortOrder("high_to_low")}
            >
              <p>Price, high to low</p>
            </div>
            <div
              className="text_holder accordion-item"
              onClick={() => setSortOrder("old_to_new")}
            >
              <p>Date, old to new</p>
            </div>
          </div> */}

          <div className="Accordion_holder">
            {options.map((option) => (
              <div
                key={option.key}
                className={`text_holder accordion-item ${
                  sortOrder === option.key ? "active" : ""
                }`}
                onClick={() => setSortOrder(option.key)}
              >
                <p>{option.label}</p>
              </div>
            ))}
          </div>
          <Green_Outline_Btn
            btnText={"Apply"}
            onClick={() => {
              dispatch(
                getAllProducts({ category_id: selectId, sortBy: sortOrder })
              );
              handleClose();
            }}
          />
          <Black_Btn
            btnText={"Reset"}
            onClick={() => {
              dispatch(
                getAllProducts({ category_id: selectId })
              );
              handleClose();
            }}
          />
          {/* <Green_round_btn btnText={"Apply"} /> */}
        </Offcanvas.Body>
      </Offcanvas>

      <Success_Modal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        successText="Apply Successfully!"
      />
    </>
  );
}

export default Sort_offcanvas;
